import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import GraphicTrendChart from "./GraphicTrendChart";

// const tabs = [
//     { id: "hr", label: "HR", unit: "bpm", color: "#3DFF3D", data: [120, 125, 123, 119, 121, 122] },
//     { id: "resp", label: "RESP", unit: "rpm", color: "#FDDF01", data: [0.2, 0.5, 0.3, 0.6, 0.8, 0.4] },
//     { id: "spo2", label: "SpO₂", unit: "%", color: "#09F4F0", data: [10, 97, 96, 95, 96, 97] },
//     { id: "nibp", label: "NIBP", unit: "mmHg", color: "#FF2B5E", data: [120, 125, 123, 119, 121, 122] },
//     { id: "inco2", label: "InCO₂", unit: "mmHg", color: "#FFF", data: [5, 4, 5.5, 4.8, 5, 5.2] },
//     { id: "temp1", label: "Temp1", unit: "℃", color: "#9B92FF", data: [36.5, 36.6, 36.7, 36.5, 36.6] },
//     { id: "temp2", label: "Temp2", unit: "℃", color: "#9B92FF", data: [36.6, 36.7, 36.8, 36.6, 36.7] },
//     { id: "etco2", label: "EtCO₂", unit: "rpm", color: "#FFF", data: [20, 21, 22, 21, 20, 22] }
// ];

function getColorForKey(key) {
    const colorMap = {
        "HR/PR(bpm)": "#3DFF3D",
        "RR(breath/min)": "#FDDF01",
        "SpO2(%)": "#09F4F0",
        "NIBP(mmHg)": "#FF2B5E",
        "EtCO2(mmHg)": "#FFF",
        "Temp1(°C)": "#9B92FF",
        "Temp2(°C)": "#9B92FF",
        "awRR(rpm)": "#FFF",
    };
    return colorMap[key] || "#FFFFFF";
}

function GraphicTrend({ trendReviewData, startTime, endTime, selectedTab }) {
    const { t } = useTranslation();
    const tabName = selectedTab.split("(")[0].trim();
    const isMultiValue = ["NIBP", "IBP 1", "IBP 2", "IBP 3", "IBP 4"].includes(tabName);
    // 선택된 탭의 데이터 추출 (data중에 - 인 경우는 제거하는 로직이 필요 할 듯)
    //const selectedData = trendReviewData[selectedTab]?.map((item) => parseFloat(item.data) || 0) || []; Rodney
    const selectedData = trendReviewData[selectedTab]?.filter((item) => item.data !== "-").map((item) => parseFloat(item.data) || 0) || [];
    const timestamps = trendReviewData.timestamps || [];

    const isCurrentTabDataNull = selectedData.every((value) => value === null);
    if (isMultiValue) {
        // "120/80/(93)" SYS: 첫 번째 값, DIA: 두 번째 값 사용
        const sysData =
            // trendReviewData[selectedTab]?.map((item) => {
                trendReviewData[selectedTab]?.filter((item) => item.data !== "-").map((item) => {
                if (item.data) {
                const parts = item.data.split("/");
                return parseFloat(parts[0].trim());
                }
                return 0;
            }) || [];
        const diaData =
            // trendReviewData[selectedTab]?.map((item) => {
            trendReviewData[selectedTab]?.filter((item) => item.data !== "-").map((item) => {
                if (item.data) {
                    const parts = item.data.split("/");
                    return parseFloat(parts[1].trim());
                }
                return 0;
        }) || [];
    
        // const sysAlarm = trendReviewData[selectedTab]?.map((item) => item.alarm) || [];
        // const diaAlarm = trendReviewData[selectedTab]?.map((item) => item.alarm) || [];
        const sysAlarm = trendReviewData[selectedTab]?.filter((item) => item.data !== "-").map((item) => item.alarm) || [];
        const diaAlarm = trendReviewData[selectedTab]?.filter((item) => item.data !== "-").map((item) => item.alarm) || [];
    
        const tabInfo = {
            color: getColorForKey(selectedTab),
            unit: selectedTab.match(/\((.*)\)/)?.[1] || "",
        };
    
        // 데이터가 모두 null 또는 NaN
        const isSysDataNull = sysData.every((value) => value === null || isNaN(value));
        const isDiaDataNull = diaData.every((value) => value === null || isNaN(value));
    
        return (
            <>
                {/* SYS 차트 */}
                <div className="bg-[#2F2F2F] py-[20px] pl-0 pt-[8px]">
                <div className="flex items-center gap-[22px] mb-[12px]">
                    <h2 className="text-lg font-light text-white my-[7px] pl-[20px]">
                        {t('trend.graphicTrend')}
                    </h2>
                </div>
                {!isSysDataNull ? (
                    <div className="h-[134px] ml-[51px] pr-[16px] font-light bg-[#383838] relative">
                    <span className="text-[11px] font-light absolute left-[-30px] top-[-17px]">
                        SYS ({tabInfo.unit})
                    </span>
                    <GraphicTrendChart
                        data={sysData}
                        alarms={sysAlarm}
                        startTime={startTime}
                        endTime={endTime}
                        color={tabInfo.color}
                        labels={timestamps}
                        unit={tabInfo.unit}
                        tooltipId="sys-tooltip"
                    />
                    </div>
                ) : (
                    <div className="w-1/3 h-[134px] ml-[51px] pr-[16px] font-light flex items-center justify-center text-[#9F9F9F]">
                        {/* No SYS data available */}
                        {t('error.noDataAvailable')}
                    </div>
                )}
                </div>
        
                {/* DIA 차트 */}
                <div className="bg-[#2F2F2F] py-[20px] pl-0 pt-[8px] mt-4">
                <div className="flex items-center gap-[22px] mb-[12px]">
                    <h2 className="text-lg font-light text-white my-[7px] pl-[20px]">
                        {t('trend.graphicTrend')}
                    </h2>
                </div>
                {!isDiaDataNull ? (
                    <div className="h-[134px] ml-[51px] pr-[16px] font-light bg-[#383838] relative">
                    <span className="text-[11px] font-light absolute left-[-30px] top-[-17px]">
                        DIA ({tabInfo.unit})
                    </span>
                    <GraphicTrendChart
                        data={diaData}
                        alarms={diaAlarm}
                        startTime={startTime}
                        endTime={endTime}
                        color={tabInfo.color}
                        labels={timestamps}
                        unit={tabInfo.unit}
                        tooltipId="dia-tooltip"
                    />
                    </div>
                ) : (
                    <div className="w-1/3 h-[134px] ml-[51px] pr-[16px] font-light flex items-center justify-center text-[#9F9F9F]">
                        {/* No DIA data available */}
                        {t('error.noDataAvailable')}
                    </div>
                )}
                </div>
            </>
        );
        } else {
            // 단일 값 탭
            const selectedData =
            //trendReviewData[selectedTab]?.map((item) => parseFloat(item.data) || 0) || [];
            trendReviewData[selectedTab]?.filter((item) => item.data !== "-").map((item) => parseFloat(item.data) || 0) || [];
            const alarmValues =
            //trendReviewData[selectedTab]?.map((item) => item.alarm) || [];
            trendReviewData[selectedTab]?.filter((item) => item.data !== "-").map((item) => item.alarm) || [];
            const tabInfo = {
            color: getColorForKey(selectedTab),
            unit: selectedTab.match(/\((.*)\)/)?.[1] || "",
            };
        
            const isCurrentTabDataNull = selectedData.every((value) => value === null || isNaN(value));
            return (
            <div className="bg-[#2F2F2F] py-[20px] pl-0 pt-[8px]">
                <div className="flex items-center gap-[22px] mb-[12px]">
                    <h2 className="text-lg font-light text-white my-[7px] pl-[20px]">Graphic Trend</h2>
                </div>
                {!isCurrentTabDataNull ? (
                    <div className="h-[134px] ml-[51px] pr-[16px] font-light bg-[#383838] relative">
                        <span className="text-[11px] font-light absolute left-[-30px] top-[-17px]">
                            {tabInfo.unit}
                        </span>
                        <GraphicTrendChart
                            data={selectedData}
                            alarms={alarmValues}
                            startTime={startTime}
                            endTime={endTime}
                            color={tabInfo.color}
                            labels={timestamps}
                            unit={tabInfo.unit}
                        />
                    </div>
                ) : (
                    <div className="w-1/3 h-[134px] ml-[51px] pr-[16px] font-light flex items-center justify-center text-[#9F9F9F]">
                        {t('error.noDataAvailable')}
                    </div>
                )}
            </div>
            );
        }
    }

export default GraphicTrend;
